/* dynamic-layout-carousel.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./dynamic-layout-carousel.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useRef, useState } from 'react';
import { cx } from '@compiled/react';
import { useDebouncedCallback } from 'use-debounce';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import { v4 as uuidv4 } from 'uuid';
import { IconButton } from '@atlaskit/button/new';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { DynamicLayoutPersonCard } from './dynamic-layout-person-card';
import { DynamicLayoutSmartLink } from './dynamic-layout-smart-link';
import { DynamicLayoutProjectHighlightCard } from './sub-agents/dynamic-layout-project-highlight-card';

// TODO: Fix wonky scroll behaviour on carousel
var carouselCardWidth = 355; // card width (300px) + gap (space.200 = 16px)
var scrollWidth = (carouselCardWidth + 46) * 2;
var styles = {
  carouselStyles: "_zulp1b66 _1e0c1txw _4cvr1y6m _kqswh2mm _2lx21bp4 _1bsb1osq",
  carouselStylesSingleRow: "_1e0c1txw _4cvr1y6m _kqswh2mm _2lx21bp4 _19pkmgjw",
  scrollContainerStyles: "_1reo1wug _18m915vq _1e0c1o8l _p12f1osq _1fjgglyw _1dm8q5uf",
  cardContainerStyles: "_zulppxbi _1e0c1txw _o5721q9c"
};
var isScrollAtLeft = function isScrollAtLeft(elem) {
  return (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) === 0;
};
var isScrollAtRight = function isScrollAtRight(elem) {
  return elem ? Math.abs((elem === null || elem === void 0 ? void 0 : elem.scrollWidth) - (elem === null || elem === void 0 ? void 0 : elem.scrollLeft) - (elem === null || elem === void 0 ? void 0 : elem.clientWidth)) <= 1 : false;
};
export var DynamicLayoutCarousel = function DynamicLayoutCarousel(_ref) {
  var _component$attributes, _component$attributes2;
  var component = _ref.component,
    position = _ref.position,
    _ref$showArrows = _ref.showArrows,
    showArrows = _ref$showArrows === void 0 ? true : _ref$showArrows;
  var scrollContainerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hideLeftScroll = _useState2[0],
    setHideLeftScroll = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hideRightScroll = _useState4[0],
    setHideRightScroll = _useState4[1];

  // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
  var key_id = useRef(uuidv4());
  var shouldAlignHeader = position === 'single-column';

  // useEffect(() => {
  // 	if (scrollContainerRef.current) {
  // 		setHideLeftScroll(isScrollAtLeft(scrollContainerRef.current));
  // 		setHideRightScroll(isScrollAtRight(scrollContainerRef.current));
  // 	}
  // }, [scrollContainerRef.current?.scrollWidth]);

  var onScroll = useDebouncedCallback(function () {
    setHideLeftScroll(isScrollAtLeft(scrollContainerRef.current));
    setHideRightScroll(isScrollAtRight(scrollContainerRef.current));
  }, 30);
  var carouselChildren = component.children || [];
  var scrollLeft = function scrollLeft() {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft -= scrollWidth;
    }
  };
  var scrollRight = function scrollRight() {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft += scrollWidth;
    }
  };
  if (!carouselChildren || carouselChildren.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(shouldAlignHeader ? styles.carouselStylesSingleRow : styles.carouselStyles)
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    grow: "fill",
    alignBlock: "center"
  }, !shouldAlignHeader && (_component$attributes = component.attributes) !== null && _component$attributes !== void 0 && _component$attributes.title ? /*#__PURE__*/React.createElement(Inline, {
    space: "space.100",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semibold",
    size: "small",
    color: "color.text.accent.gray"
  }, (_component$attributes2 = component.attributes) === null || _component$attributes2 === void 0 ? void 0 : _component$attributes2.title)) : /*#__PURE__*/React.createElement(Box, null), showArrows && /*#__PURE__*/React.createElement(Inline, {
    space: "space.100"
  }, !hideLeftScroll && /*#__PURE__*/React.createElement(IconButton, {
    icon: ArrowLeftIcon,
    label: "scroll left",
    onClick: scrollLeft,
    shape: "circle",
    appearance: "subtle",
    spacing: "compact"
  }), !hideRightScroll && /*#__PURE__*/React.createElement(IconButton, {
    icon: ArrowRightIcon,
    label: "scroll right",
    onClick: scrollRight,
    shape: "circle",
    appearance: "subtle",
    spacing: "compact"
  }))), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.scrollContainerStyles,
    ref: scrollContainerRef,
    onScroll: onScroll
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.cardContainerStyles
  }, carouselChildren.map(function (child) {
    //TODO : move to a separate component
    if (typeof child !== 'string' && child.tag === 'people-card') {
      return /*#__PURE__*/React.createElement(DynamicLayoutPersonCard, {
        component: child,
        key: "".concat(child.tag, "-").concat(key_id)
      });
    }
    if (typeof child !== 'string' && child.tag === 'smart-link') {
      return /*#__PURE__*/React.createElement(DynamicLayoutSmartLink, {
        component: child,
        key: "".concat(child.tag, "-").concat(key_id)
      });
    }
    if (typeof child !== 'string' && child.tag === 'project-highlight-card') {
      return /*#__PURE__*/React.createElement(DynamicLayoutProjectHighlightCard, {
        component: child,
        key: "".concat(child.tag, "-").concat(key_id)
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(key_id)
    });
  }))));
};